import { Component, input, output } from '@angular/core';
import { EIconPath } from '../../../../../../shared/enums/icons.enum';
import { TColumn } from '../../../../site-table/columns/column.model';
import { ESortOrder } from '../../../../site-table/sort-order-enum';

@Component({
  selector: 'pp-new-group-or-sort-column',
  templateUrl: './new-group-or-sort-column.component.html',
  styleUrls: ['./new-group-or-sort-column.component.scss'],
  standalone: false,
})
export class NewGroupOrSortColumnComponent {
  EIconPath = EIconPath;
  emptyGroupOrder: ESortOrder;

  ppOrder = input<number>();
  ppType = input<'group' | 'sort'>();

  ppAddGroup = output<TColumn>();
  ppCancel = output<void>();

  updateEmptyGroupOrder(order: ESortOrder): void {
    this.emptyGroupOrder = order;
  }

  updateEmptyGroupColumn(column: TColumn): void {
    this.ppAddGroup.emit({
      ...column,
      groupOrder: this.emptyGroupOrder || ESortOrder.ASC,
    });
  }

  cancel(): void {
    this.ppCancel.emit();
  }
}
